import { DateRangeFilter } from "@/components/date-filter/DateRangeFilter.tsx";
import { FilterItem, filtersLibrary } from "@/components/filter/filter.types.ts";
import { useRecognitions } from "@/queries/use-recognitions.query.ts";
import { CoreFilterType, FilterRenderType, FilterValueType, Multiselect } from "@skailer-com/uikit";
import { useMemo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export function useRecognitionHistoryFilters(): FilterItem[] {
  const { t } = useTranslation();
  const library = filtersLibrary();
  const { data: recognitions } = useRecognitions();

  const recognitionOptions = useMemo(
    () => (recognitions ?? []).map((item) => ({ id: item.id, title: item.title })),
    [recognitions]
  );

  return [
    library.page_number,
    library.text,
    { ...library.employee_ids, label: t("recognition:filter_recipient") },
    library.department_ids,
    {
      name: "recognition_ids",
      type: CoreFilterType.hidden,
      valueType: FilterValueType.numberArray,
      renderType: FilterRenderType.custom,
      label: t("recognition:filter_recognitions"),
      render: (item, { control }) => (
        <Controller
          control={control}
          name={item.name}
          render={({ field }) => (
            <Multiselect
              label={item.label}
              options={recognitionOptions}
              values={field.value}
              onChange={field.onChange}
              searchable
              isClearable
              emptyTitle={t("common:select")}
            />
          )}
        />
      ),
    },
    {
      ...library.employee_ids,
      name: "awarded_by_ids",
      label: t("recognition:filter_awarded_by"),
    },
    { ...library.date_from, hideInFilter: true },
    { ...library.date_to, hideInFilter: true },
    {
      name: "date_range",
      type: CoreFilterType.hidden,
      valueType: FilterValueType.string,
      renderType: FilterRenderType.custom,
      label: t("common:period"),
      render: (item, { control }) => (
        <Controller
          control={control}
          name={library.date_from.name}
          render={({ field: fromField }) => (
            <Controller
              control={control}
              name={library.date_to.name}
              render={({ field: toField }) => (
                <DateRangeFilter
                  title={item.label ?? t("common:period")}
                  from={fromField.value ?? undefined}
                  to={toField.value ?? undefined}
                  onChange={({ from, to }) => {
                    fromField.onChange(from ?? null);
                    toField.onChange(to ?? null);
                  }}
                />
              )}
            />
          )}
        />
      ),
    },
  ];
}
